<div id="attachemnt-documents" pageheight>
  <div>
    <p-toolbar>
      <div class="p-toolbar-group-start pl-1"></div>
      <div class="p-toolbar-group-end pr-2">
        <div class="formgroup-inline searchbox-button">
          <div class="field">
            <div class="p-inputgroup">
              <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
              <input
                type="text"
                id="attachment"
                pInputText
                placeholder="Search on Name,Owner,Status"
                class="form-control form-control-sm"
                [(ngModel)]="searchText"
                #searchTextElementRef
                name="search"
              />
              <span class="p-inputgroup-addon d-none" id="btnResetSearch"><i class="pi pi-times"></i></span>
            </div>
          </div>
          <p-button
            icon="pi pi-plus"
            class="px-2 py-2"
            label="{{ 'ADD_ATTACHMENTS' | translate }}"
            (onClick)="uploadFiles.click()"
            *ngIf="!disallowEdit"
          />
          <p-button
            icon="pi pi-plus"
            class="px-0 py-2"
            label="{{ 'ADD_LINK' | translate }}"
            (onClick)="showLinkModal('add')"
            *ngIf="!disallowEdit"
          />
          <input type="file" hidden multiple (change)="uploadSelectedFiles($event.target)" #uploadFiles />
        </div>
      </div>
    </p-toolbar>
  </div>

  <div class="attachments-table-container">
    <div class="row section-table-container">
      <div class="eva-v2-table-container attachement-table-container pr-1">
        <div class="col-12">
          <table id="futree" class="table futree" #futree>
            <colgroup>
              <col width="50px;" />
              <col width="300px" />
              <col />
              <col />
              <col />
            </colgroup>
            <thead>
              <tr>
                <th></th>
                <th class="sortable asc" data-column="title" (click)="sortFunction('title')">
                  <span class="header_icon">{{ 'FILE_NAME' | translate }}</span>
                  <span
                    class="sort-icon"
                    [ngClass]="{ asc: sortDirection === 'asc', desc: sortDirection === 'desc' }"
                  ></span>
                </th>
                <th class="sortable" data-column="owner" (click)="sortFunction('owner')">
                  <span class="header_icon">{{ 'OWNER' | translate }}</span>
                  <span
                    class="sort-icon"
                    [ngClass]="{ asc: sortDirection === 'asc', desc: sortDirection === 'desc' }"
                  ></span>
                </th>
                <th class="sortable" data-column="date" (click)="sortFunction('date')">
                  <span class="header_icon">{{ 'UPLOADED_ON' | translate }}</span>
                  <span
                    class="sort-icon"
                    [ngClass]="{ asc: sortDirection === 'asc', desc: sortDirection === 'desc' }"
                  ></span>
                </th>
                <th class="sortable" data-column="status" (click)="sortFunction('status')">
                  <span class="header_icon status">{{ 'STATUS' | translate }}</span>
                  <span
                    class="sort-icon"
                    [ngClass]="{ asc: sortDirection === 'asc', desc: sortDirection === 'desc' }"
                  ></span>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <!-- Define a row template for all invariant markup: -->
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td class="attachment-status"></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="isLoading" class="col-12 d-flex justify-content-center">
          <p-progress-spinner></p-progress-spinner>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog [(visible)]="hasDoc" [style]="{ width: '90vw' }" [modal]="true" appendTo="body">
  <div *ngIf="doc?.url">
    <ngx-doc-viewer [url]="doc.url" viewer="google" style="width: 100%; height: 80vh"></ngx-doc-viewer>
    <!-- <iframe width="100%" height="80vh" ngx-document frameBorder="0" [src]="urlSafe" provider="google"></iframe> -->
  </div>
</p-dialog>
<p-dialog
  [header]="linkHeader"
  [(visible)]="showLink"
  [style]="{ width: '30vw' }"
  [modal]="true"
  appendTo="body"
  [baseZIndex]="9999"
  [draggable]="false"
  [closable]="false"
>
  <form [formGroup]="linkDetails" class="model-popup">
    <div class="form-group row">
      <label for="linkName" class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-form-label required">{{
        'LINK_NAME' | translate
      }}</label>
      <div class="col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8">
        <input
          type="text"
          placeholder="{{ 'LINK_NAME' | translate }}"
          class="form-control"
          formControlName="linkName"
          maxlength="128"
          minlength="1"
          required
          [ngClass]="{ 'error-border': submitted && linkDetails.get('linkName')?.hasError('required') }"
        />
        <small *ngIf="submitted && linkDetails.get('linkName')?.hasError('required')" class="input-error-text">
          <span [innerHtml]="'LINK_NAME_ERR_MSG' | translate"></span>
        </small>

        <p-dialog
          [header]="linkHeader"
          [(visible)]="showLink"
          [style]="{ width: '45vw' }"
          [modal]="true"
          appendTo="body"
          [baseZIndex]="9999"
          [draggable]="false"
          [closable]="false"
          (onHide)="closeDialog()"
        >
          <form [formGroup]="linkDetails" (ngSubmit)="onUpdateLink(updateSidLink)" class="model-popup">
            <div class="form-group row">
              <label for="linkName" class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-form-label required">{{
                'LINK_NAME' | translate
              }}</label>
              <div class="col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8">
                <input
                  type="text"
                  placeholder="{{ 'LINK_NAME' | translate }}"
                  class="form-control"
                  maxlength="128"
                  minlength="1"
                  formControlName="linkName"
                  alphaNumWithSpace
                  required
                />
                <small
                  class="input-error-text"
                  *ngIf="
                    (linkDetails.get('linkName')?.hasError('required') ||
                      linkDetails.get('linkName')?.hasError('pattern') ||
                      linkDetails.get('linkName')?.hasError('duplicate')) &&
                    submitted
                  "
                >
                  <span *ngIf="linkDetails.get('linkName')?.hasError('required') && submitted">
                    {{ 'LINK_NAME_ERR_MSG' | translate }}
                  </span>
                  <span class="input-error-text" *ngIf="linkDetails.get('linkName')?.hasError('pattern') && submitted">
                    Only alphanumeric characters allowed for Name. Link Name should start with an alphabet
                  </span>
                  <span
                    class="input-error-text"
                    *ngIf="linkDetails.get('linkName')?.hasError('duplicate') && submitted"
                  >
                    Link Name should be Unique
                  </span>
                </small>
              </div>
            </div>
            <div class="form-group row">
              <label for="linkUrl" class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-form-label required">{{
                'LINK_URL' | translate
              }}</label>
              <div class="col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8">
                <input
                  type="text"
                  placeholder="{{ 'LINK_URL' | translate }}"
                  class="form-control"
                  formControlName="linkUrl"
                  required
                  [ngClass]="{
                    'error-border':
                      submitted &&
                      (linkDetails.get('linkUrl')?.hasError('required') ||
                        linkDetails.get('linkUrl')?.hasError('pattern'))
                  }"
                />
                <small
                  *ngIf="
                    submitted &&
                    (linkDetails.get('linkUrl')?.hasError('required') ||
                      linkDetails.get('linkUrl')?.hasError('pattern'))
                  "
                  class="input-error-text"
                >
                  <span
                    *ngIf="linkDetails.get('linkUrl')?.hasError('required')"
                    [innerHtml]="'LINK_URL_ERR_MSG' | translate"
                  ></span>
                  <span
                    *ngIf="linkDetails.get('linkUrl')?.hasError('pattern')"
                    [innerHtml]="'LINK_URL_ID_NOT_VALID' | translate"
                  ></span>
                </small>
              </div>
            </div>
          </form>
          <ng-template #footer>
            <div class="modal-button">
              <button type="button" class="btn btn-primary cancel-btn" (click)="closeDialog()">
                {{ 'CANCEL' | translate }}
              </button>
              <button type="submit" class="btn btn-primary" (click)="onUpdateLink(updateSidLink)">
                {{ (linkHeader === 'Edit Link' ? 'UPDATE' : 'ADD') | translate }}
              </button>
            </div>
          </ng-template>
        </p-dialog>
      </div>
    </div></form
></p-dialog>
